import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment"

const nf2 = new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}); 


export default function TableMovementItem({ item,index }) {

    const {
        mov_date,
        folio,
        dias_vencidos,
        pieces,
        kgs,
        total_vta,
        merma,
        venta_neta,
        cobro,
        balance,
        pagos,
        pagado,
        fecha,
        nota_credito,
        nota_cargo,
        payments,
        pv,
        mortalidad_descuento
    } = item;

    return (
        <>
            <tr>
                <td className="text-end">
                    {index+1}
                </td>
                <td className="text-end">
                    {fecha}
                </td>
                <td className="text-right">
                    { 'Nota de venta' }
                </td>
                <td className="text-right">
                    { folio }
                </td>
                <td className="text-right">
                    { (total_vta - payments) > 0 ? new Intl.NumberFormat('es-MX').format(dias_vencidos) : '' }
                </td>
                <td className="text-right">
                    { new Intl.NumberFormat('es-MX').format(pieces) }
                </td>
                <td  className={"text-right "}>
                    { nf2.format(kgs) }
                </td>
                <td  className={"text-right "}>
                    { nf2.format(pv) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(total_vta) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(merma) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(mortalidad_descuento) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(nota_credito) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(nota_cargo) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(venta_neta) }
                </td>   
                <td className={"text-right "}>
                    { nf2.format(payments) }
                </td>
                <td className={"text-right "}>
                    { nf2.format(balance) }
                </td>
            </tr>
        </>
    );
}

TableMovementItem.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number
};